import {Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-slider-hotpot',
  templateUrl: './SliderHotpot.component.html',
  styleUrls: ['./SliderHotpot.component.scss']
})
export class SliderHotpotComponent implements OnInit {

  public sliderConfig = {
    'slidesToShow': 5,
    'slidesToScroll': 1,
    'cssEase': 'linear',
    'arrows': false,
    'fade': false,
    'dots': false,
    'autoplay': true,
    'autoplaySpeed': 1500,
    'responsive': [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 567,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  };

  constructor() {
  }

  ngOnInit() {
  }

}
